import React from "react";
import ActivityAction from "../ActivityAction/ActivityAction";

const DeleteActivityItem = ({
  isDocument,
  document,
  isFolder,
  folder,
  isSubFile,
  subFile,
  openDocument,
  openFolder,
  hasAccess,
}) => (
  <>
    deleted{" "}
    {isDocument ? (
      <>
        {document.title} from{" "}
        <ActivityAction
          {...{
            title: document.folder.title,
            onClick: () => openFolder(document.folder),
            isDocument,
            isFolder,
            inTrash: document.folder.inTrash,
            hasAccess,
          }}
        />
      </>
    ) : isFolder ? (
      folder.title
    ) : isSubFile ? (
      <>
        {subFile.length === 1 ? <>a sub-file {subFile[0].title}</> : `${subFile.length} sub-files`}
        {` from`}{" "}
        <ActivityAction
          {...{
            title: document.title,
            onClick: () => openDocument(document.id),
            isDocument: true,
            isFolder,
            inTrash: document.inTrash,
            hasAccess,
          }}
        />
      </>
    ) : (
      ""
    )}
  </>
);

export default DeleteActivityItem;
